import LottoController from './controller/LottoController';

const lottoManager = new LottoController();
lottoManager.init();
